import { Container } from '@mui/material';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { NotFound } from 'app/components/not-found';

import { OverallMetrics } from './overall-metrics';
import { StoreMetrics } from './store-metrics';

export class MetricsRouter extends React.Component {
    public render(): React.ReactNode {
        return (
            <Container maxWidth={false} className='py-3 remaining-height'>
                <Switch>
                    <Route exact path='/seam/metrics'>
                        <OverallMetrics />
                    </Route>
                    <Route path='/seam/metrics/store'>
                        <StoreMetrics />
                    </Route>
                    <Route path='*'>
                        <NotFound />
                    </Route>
                </Switch>
            </Container>
        );
    }
}
